export const ItemTypes = {
  FIELD: 'field',
  CARD: 'card',
};
